import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import Success from './Success';

// Selectors
import { getIsDealerOpenNow } from 'store/reducers/selfCheckIn/selectors';

const mapStateToProps = state => {
  return {
    isDealerOpen: getIsDealerOpenNow(state)
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps)
)(Success);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Success/SuccessContainer.js